import axios from "axios";

// ==========================
// 🔹 Base URL Configuration
// ==========================
const API_URL = window.location.hostname.includes("localhost")
  ? process.env.VUE_APP_API_PRODUCTION
  : process.env.VUE_APP_API_LOCAL;

// ==========================
// 🔹 All Endpoints
// ==========================
const ENDPOINTS = {
  // Auth
  SIGNUP: process.env.VUE_APP_ENDPOINT_SIGNUP,
  LOGIN: process.env.VUE_APP_ENDPOINT_LOGIN,

  // States
  STATES: process.env.VUE_APP_ENDPOINT_STATES,

  // Categories
  CATEGORIES: process.env.VUE_APP_ENDPOINT_CATEGORIES,

  // Tax Rules
  TAX_RULES: process.env.VUE_APP_ENDPOINT_TAX_RULES,

  // Tax Calculation
  CALCULATE_TAX: process.env.VUE_APP_ENDPOINT_CALCULATE_TAX,

  // File Operations
  FILE_UPLOAD: process.env.VUE_APP_ENDPOINT_FILE_UPLOAD,
  DOWNLOAD_FILE: process.env.VUE_APP_ENDPOINT_DOWNLOAD_FILE,

  // Products
  PRODUCTS_UPLOAD: process.env.VUE_APP_ENDPOINT_PRODUCTS_UPLOAD,
  PRODUCTS_LIST: process.env.VUE_APP_ENDPOINT_PRODUCTS_LIST,
  PRODUCTS_ADD: process.env.VUE_APP_ENDPOINT_PRODUCTS_ADD,
  PRODUCTS_DELETE: process.env.VUE_APP_ENDPOINT_PRODUCTS_DELETE,
  PRODUCTS_EDIT: process.env.VUE_APP_ENDPOINT_PRODUCTS_EDIT,
  PRODUCTS_CALCULATE_TAX: process.env.VUE_APP_ENDPOINT_PRODUCTS_CALCULATE_TAX,

  // PACT Act
  PACTACT_DOWNLOAD: process.env.VUE_APP_ENDPOINT_PACTACT_DOWNLOAD,
  PACTACT_UPLOAD: process.env.VUE_APP_ENDPOINT_PACTACT_UPLOAD,

  // Companies
  COMPANIES_ADD: process.env.VUE_APP_ENDPOINT_COMPANIES_ADD,
  COMPANIES_GET: process.env.VUE_APP_ENDPOINT_COMPANIES_GET,
  COMPANIES_UPDATE: process.env.VUE_APP_ENDPOINT_COMPANIES_UPDATE,
  COMPANIES_DELETE: process.env.VUE_APP_ENDPOINT_COMPANIES_DELETE,
};

// ==========================
// 🔹 Axios Instance
// ==========================
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ==========================
// 🔹 Auth APIs
// ==========================
export const registerUser = (userData) =>
  apiClient.post(ENDPOINTS.SIGNUP, userData);

export const loginUser = (credentials) =>
  apiClient.post(ENDPOINTS.LOGIN, credentials);

// ==========================
// 🔹 States APIs
// ==========================
export const GetStates = () => apiClient.get(ENDPOINTS.STATES);

export const UpdateStateTaxApplicableStatus = (id, data) =>
  apiClient.put(`${ENDPOINTS.STATES}${id}/`, data);

// ==========================
// 🔹 Categories APIs
// ==========================
export const GetCategories = () => apiClient.get(ENDPOINTS.CATEGORIES);

export const AddCategory = (data) => apiClient.post(ENDPOINTS.CATEGORIES, data);

export const EditCategoryName = (id, data) =>
  apiClient.put(`${ENDPOINTS.CATEGORIES}${id}/`, data);

export const ChangeCategoryStatus = (id, is_active) =>
  apiClient.patch(`${ENDPOINTS.CATEGORIES}${id}/`, { is_active });

// ==========================
// 🔹 Tax Rules APIs
// ==========================
export const GetTaxRules = () => apiClient.get(ENDPOINTS.TAX_RULES);

export const AddRules = (data) => apiClient.post(ENDPOINTS.TAX_RULES, data);

export const UpdateTaxRules = (id, data) =>
  apiClient.put(`${ENDPOINTS.TAX_RULES}${id}/`, data);

export const EditTaxRules = (id, data) =>
  apiClient.put(`${ENDPOINTS.TAX_RULES}${id}/`, data);

export const DeleteTaxRulesdata = (id) =>
  apiClient.delete(`${ENDPOINTS.TAX_RULES}${id}/`);

// ==========================
// 🔹 Tax Calculation APIs
// ==========================
export const AddTaxCalculation = (data) =>
  apiClient.post(ENDPOINTS.CALCULATE_TAX, data);

// ==========================
// 🔹 File Operations APIs
// ==========================
export const UploadCSVfile = (data) =>
  apiClient.post(ENDPOINTS.FILE_UPLOAD, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const downloadProcessedTaxResults = (filePath) =>
  apiClient.get(ENDPOINTS.DOWNLOAD_FILE, {
    params: { file_path: filePath },
    responseType: "blob",
  });

// ==========================
// 🔹 Product APIs
// ==========================
export const UploadProductCSVfile = (data) =>
  apiClient.post(ENDPOINTS.PRODUCTS_UPLOAD, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const GetPaginatedProductList = (page = 1, pageSize = 10, search = "") =>
  apiClient.get(ENDPOINTS.PRODUCTS_LIST, {
    params: { page, page_size: pageSize, search },
  });

export const AddProduct = (data) => apiClient.post(ENDPOINTS.PRODUCTS_ADD, data);

export const MultiplesDeletedProduct = (ids) =>
  apiClient.delete(ENDPOINTS.PRODUCTS_DELETE, { data: { ids } });

export const DeletsingleProduct = (id) =>
  apiClient.delete(`${ENDPOINTS.PRODUCTS_DELETE}${id}/`);

export const UpdateProduct = (id, productData) =>
  apiClient.put(`${ENDPOINTS.PRODUCTS_EDIT}${id}/`, productData);

export const SKUTaxCalculation = (data) =>
  apiClient.post(ENDPOINTS.PRODUCTS_CALCULATE_TAX, data);

// ==========================
// 🔹 PACT Act APIs
// ==========================
export const downloadPACTActFile = (state, month, year) =>
  apiClient.get(ENDPOINTS.PACTACT_DOWNLOAD, {
    params: { state, month, year },
    responseType: "blob",
  });

export const UploadPACTActCSV = (data) =>
  apiClient.post(ENDPOINTS.PACTACT_UPLOAD, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// ==========================
// 🔹 Companies APIs
// ==========================
export const AddCompany = (data) => apiClient.post(ENDPOINTS.COMPANIES_ADD, data);

export const GetCompanies = () => apiClient.get(ENDPOINTS.COMPANIES_GET);

export const GetCompany = (id) =>
  apiClient.get(`${ENDPOINTS.COMPANIES_GET}${id}/`);

export const UpdateCompany = (id, data) =>
  apiClient.put(`${ENDPOINTS.COMPANIES_UPDATE}${id}/`, data);

export const DeleteCompany = (id) =>
  apiClient.delete(`${ENDPOINTS.COMPANIES_DELETE}${id}/`);
